module.exports = __webpack_public_path__ + "img/frame (228).932b9c77.jpg";